// QR module: resolves the opaque 4-char vet code into localStorage, which
// custom-atc.js / product-form.js already read verbatim as the cart's
// properties[doctorId] line item property. The code — never a real
// doctor_id, those never leave the server — arrives here either as
// ?ref=<code> right after the /r/<code> redirect, the animeal_vet_ref
// cookie on every later page view (set server-side on every scan, so it
// always holds the most recently scanned vet), a code already saved in
// localStorage from an earlier page view, or — if none of those exist — a
// code the patient types by hand (the poster/standee both print "Or mention
// code XXXX when you order" as a fallback for when the QR itself won't
// scan). Runs on every page load so "last touch wins": a later scan's
// cookie value always overwrites whatever was stored before.
//
// This replaces the old AES-encrypted ?doctor_id= + CryptoJS decrypt logic
// still present (inert) in custom-mw.min2.js — no new QR code will ever
// produce a ?doctor_id= param, so that old path never runs again.
(function () {
  function getRefCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function saveDoctorId(code) {
    localStorage.setItem('doctor_id', code);
  }

  // Every place a "Doctor's Name" field exists: the two global popups
  // (theme.liquid renders both on every page) plus the dedicated
  // /pages/upload-prescription page's own section.
  var DOCTOR_NAME_FIELD_IDS = ['doc-name', 'cust_doc-name', 'doc-name-sec'];

  // Auto-fills and locks a "Doctor's Name" field with the actual referring
  // vet's name/clinic, so the customer sees confirmation of who referred
  // them instead of typing it manually.
  function lockDoctorNameField(input, label) {
    if (!input) {
      return;
    }
    input.value = label;
    input.readOnly = true;
    input.style.backgroundColor = '#f0f0f0';
    input.style.cursor = 'not-allowed';
  }

  // Resolves a code via the public lookup endpoint and, on success, saves it
  // (commission attribution) and locks both Doctor's Name fields (display).
  // Shared by the automatic path (url/cookie/localStorage) and the manual
  // fallback field, so both end up in exactly the same state once resolved.
  function resolveAndApply(code, callbacks) {
    callbacks = callbacks || {};
    fetch('https://nodejs.animeal.in/api/vet/' + encodeURIComponent(code))
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (vet) {
        if (!vet || !vet.name) {
          if (callbacks.onNotFound) callbacks.onNotFound();
          return;
        }
        saveDoctorId(code);
        var label = vet.clinic ? vet.name + ' — ' + vet.clinic : vet.name;
        DOCTOR_NAME_FIELD_IDS.forEach(function (id) {
          lockDoctorNameField(document.getElementById(id), label);
        });
        if (callbacks.onFound) callbacks.onFound(vet);
      })
      .catch(function (err) {
        console.error('Failed to resolve vet code:', err);
        if (callbacks.onError) callbacks.onError(err);
      });
  }

  function setStatus(el, text, color) {
    if (!el) return;
    el.textContent = text;
    el.style.color = color || '';
  }

  // Reveals the "Or enter your vet's code" fallback field(s) and wires them
  // up: as soon as 4 characters are typed, resolve it exactly like a scan.
  function enableManualCodeEntry() {
    var variants = [
      { prefix: '', nameId: 'doc-name' },
      { prefix: 'cust_', nameId: 'cust_doc-name' },
      { prefix: 'sec_', nameId: 'doc-name-sec' },
    ];

    variants.forEach(function (variant) {
      var manual = document.getElementById(variant.prefix + 'vet-code-manual');
      var input = document.getElementById(variant.prefix + 'vet-code-input');
      var status = document.getElementById(variant.prefix + 'vet-code-status');
      if (!manual || !input) {
        return;
      }
      manual.style.display = '';

      input.addEventListener('input', function () {
        var typed = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        input.value = typed;
        setStatus(status, '');
        if (typed.length !== 4) {
          return;
        }

        setStatus(status, 'Checking…', '#888');
        resolveAndApply(typed, {
          onFound: function (vet) {
            input.readOnly = true;
            setStatus(status, 'Linked to ' + vet.name, '#0F6E56');
          },
          onNotFound: function () {
            setStatus(status, 'Code not found — check and try again', '#b00020');
          },
          onError: function () {
            setStatus(status, 'Could not verify code — check your connection', '#b00020');
          },
        });
      });
    });
  }

  function init() {
    var url = new URL(window.location.href);
    var existingCode =
      url.searchParams.get('ref') ||
      getRefCookie('animeal_vet_ref') ||
      localStorage.getItem('doctor_id');

    if (!existingCode) {
      enableManualCodeEntry();
      return;
    }

    existingCode = existingCode.toUpperCase();
    resolveAndApply(existingCode);
  }

  init();
})();
